(function () {
  var STORAGE_KEY = 'josmeyer:announcement-bar-dismissed';
  var bar = document.querySelector('.announcement-bar-section .utility-bar');
  var closeButton = document.querySelector('.announcement-bar__close');
  if (!bar) return;

  var hideBar = function () {
    bar.style.display = 'none';
    // The header's floating position (component-header-island.css) is
    // pushed down by --josmeyer-announcement-height, measured from this
    // bar's real height (header-drawer.liquid) — dispatching resize makes
    // it re-measure now that the bar is hidden (height back to 0),
    // instead of duplicating that measurement logic here.
    window.dispatchEvent(new Event('resize'));
  };

  if (sessionStorage.getItem(STORAGE_KEY) === '1') {
    hideBar();
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      sessionStorage.setItem(STORAGE_KEY, '1');
      hideBar();
    });
  }
})();
